/* eslint-disable react-hooks/exhaustive-deps */
/**
 * ShareProvider
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import useModal from '../use-modal/use-modal'
import SocialMedia from '../../ui/social-media'

export default function ShareHook() {
  const modal = useModal()
  const { t } = useTranslation()
  const share = ({
    url,
    imageUrl,
    title,
    message,
    modalDialogTitle,
    modalDialogMessage,
  }) => {
    if (navigator.share) {
      navigator.share({
        title,
        text: message,
        url,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
        .catch(console.error);
    } else {
      modal.open({
        title: modalDialogTitle,
        message: modalDialogMessage,
        contentComponent: <SocialMedia
          scale="2"
          marginIcon="0 2rem 0 0"
          title={message}
          imageUrl={imageUrl}
          // classN={styles.shareGroup}
          shareUrl={url}
        />,
        buttons: [{
          text: t('ui.share.modalDialog.buttons.dismiss'),
          onClick: () => modal.close(),
        }],
      })
    }
  }

  return {
    share,
  }
}
